import { render, staticRenderFns } from "./CompareAgencies.vue?vue&type=template&id=1bceb4b2"
import script from "./CompareAgencies.vue?vue&type=script&lang=js"
export * from "./CompareAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports